export default "__VITE_ASSET__wd3tuMUO__"